module.exports = __webpack_public_path__ + "img/icon.ad8a533c.png";